import AddStorePermission from "./AddStorePermision";
import { TStaffPermissionStep } from "./interface";

const StaffPermissionStep = ({
  defaultPermission,
  structuredPermission,
  setStoreDetails,
  setDefaultPermission,
  permissionHeading
}: TStaffPermissionStep) => {
  return (
        <AddStorePermission
          defaultPermission={defaultPermission}
          structuredPermission={structuredPermission}
          setStoreDetails={setStoreDetails}
          setDefaultPermission={setDefaultPermission}
          permissionHeading={permissionHeading}
          permissionKey="staff_permissions"
        />
  );
};

export default StaffPermissionStep;
